import { Moment } from 'moment';
import {
	Column,
	Entity,
	JoinColumn,
	OneToOne,
	PrimaryGeneratedColumn,
} from 'typeorm';
import { GenPartial, momentTransformer } from 'typeormgen';
import Base from '../base.entity';
import Type from '../types/type.entity';

// TODO: figure out a better name for this entity
@Entity('searchable_entity_deletions')
export default class SearchableEntityDeletion extends Base {
	static tableName = 'searchable_entity_deletions';

	static skipUpdateColumns = ['id', 'type_id', 'table_name'];

	@PrimaryGeneratedColumn()
	id: number;

	@Column('int')
	type_id: number;

	@Column('varchar')
	table_name: string;

	@Column({ type: 'timestamp', transformer: momentTransformer })
	last_deletion_check: Moment;

	@OneToOne((type) => Type)
	@JoinColumn({
		name: 'type_id',
	})
	type: Type;

	toJSON() {
		return {
			id: this.id,
			type_id: this.type_id,
			table_name: this.table_name,
			last_deletion_check: this.last_deletion_check,
		};
	}

	assign(props?: GenPartial<SearchableEntityDeletion>) {
		super.assign(props);

		if (props) {
			if (typeof props.last_deletion_check !== 'undefined') {
				this.last_deletion_check = momentTransformer.from(
					props.last_deletion_check
				);
			}
		}
	}

	constructor(props?: GenPartial<SearchableEntityDeletion>) {
		super(props);
	}
}
